import { ThemeScreenProps } from "../types";
import { resolveColor, MOCK_CART_ITEM, MOCK_CART_TOTALS } from "../constants";
import {
  CartPage,
  OrderTypeRow,
  OrderTypeBtn,
  CartScrollContent,
  CartItemSection,
  CartItemTitle,
  CartQtyRow,
  CartQtyBtn,
  CartQtyNum,
  CartItemPrice,
  CartItemImg,
  CartModGroup,
  CartModGroupLabel,
  CartModItemRow,
  CartModItemName,
  CartModItemPrice,
  CartBackBtn,
  CartFooterSection,
  CartUtensilsRow,
  CartTotalsBlock,
  CartTotalRow,
  CartTotalLabel,
  CartTotalValue,
  CartCheckoutBtn,
} from "../styles";

function CartScreen({ colors }: ThemeScreenProps) {
  const primary = resolveColor(colors.primaryColor, "#e53935");
  const bg = resolveColor(colors.backgroundColor, "#f5f5f5");
  const primaryText = resolveColor(colors.primaryTextColor, "#1a1a1a");
  const secondaryText = resolveColor(colors.secondaryTextColor, "#888888");

  return (
    <CartPage $bg={bg}>
      <OrderTypeRow>
        <OrderTypeBtn $active={false} $color={primary}>
          <span>🍽</span>
          <span>Dine-In</span>
        </OrderTypeBtn>
        <OrderTypeBtn $active={true} $color={primary}>
          <span>🛍</span>
          <span>Takeaway</span>
        </OrderTypeBtn>
      </OrderTypeRow>

      <CartScrollContent>
        <CartItemSection>
          <CartItemTitle $color={primary}>{MOCK_CART_ITEM.name}</CartItemTitle>

          <CartQtyRow>
            <CartQtyBtn $color={primary}>−</CartQtyBtn>
            <CartQtyNum>{MOCK_CART_ITEM.qty}</CartQtyNum>
            <CartQtyBtn $color={primary}>+</CartQtyBtn>
          </CartQtyRow>

          <CartItemPrice $color={primaryText}>{MOCK_CART_ITEM.price}</CartItemPrice>

          <CartItemImg>{MOCK_CART_ITEM.emoji}</CartItemImg>

          {MOCK_CART_ITEM.modifiers.map((mod, i) => (
            <CartModGroup key={i}>
              <CartModGroupLabel>{mod.group}</CartModGroupLabel>
              <CartModItemRow>
                <CartModItemName $color={primaryText}>{mod.item}</CartModItemName>
                <CartModItemPrice $color={secondaryText}>{mod.price}</CartModItemPrice>
              </CartModItemRow>
            </CartModGroup>
          ))}
        </CartItemSection>

        <CartBackBtn>Back To Home</CartBackBtn>
      </CartScrollContent>

      <CartFooterSection>
        <CartUtensilsRow>
          <input type="checkbox" style={{ width: 8, height: 8 }} readOnly />
          <span>Include Utensils, napkins with</span>
        </CartUtensilsRow>

        <CartTotalsBlock>
          <CartTotalRow>
            <CartTotalLabel $color={primaryText}>Subtotal</CartTotalLabel>
            <CartTotalValue $color={primaryText}>{MOCK_CART_TOTALS.subtotal}</CartTotalValue>
          </CartTotalRow>
          <CartTotalRow>
            <CartTotalLabel $color={secondaryText}>Tax ({MOCK_CART_TOTALS.taxRate})</CartTotalLabel>
            <CartTotalValue $color={secondaryText}>{MOCK_CART_TOTALS.tax}</CartTotalValue>
          </CartTotalRow>
          <CartTotalRow>
            <CartTotalLabel $bold $color={primaryText}>Total</CartTotalLabel>
            <CartTotalValue $bold $color={primaryText}>{MOCK_CART_TOTALS.total}</CartTotalValue>
          </CartTotalRow>
        </CartTotalsBlock>

        <CartCheckoutBtn $color={primary}>CHECKOUT</CartCheckoutBtn>
      </CartFooterSection>
    </CartPage>
  );
}

export default CartScreen;
